<div class="layout-column threepl-services-item">
  <div class="layout-row layout-align-start-center br-body-2 text-ellipsis">
    <bz-tag [tone]="service().status | threeplStatusTone" class="margin-right-5">{{ service().status | translate }}</bz-tag>
    <app-threepl-service-link class="margin-right-5" [serviceId]="service().id" [externalId]="service().externalId"></app-threepl-service-link>

    <span class="flex"></span>

    @if (columns()?.supplierAccount) {
      <div class="layout-row layout-align-start-center br-body-2 margin-right-5">
        <span class="flex">{{ 'Carrier' | translate }}</span>:
        <app-shipper-account-link-tooltip class="margin-left-5" [account]="service().supplierAccountReference"></app-shipper-account-link-tooltip>
      </div>
    }

    @if (columns()?.eta) {
      <div class="layout-row layout-align-start-center br-body-2">
        <span class="flex">{{ 'ETA' | translate }}</span>:
        <span class="margin-left-5">{{ service() | bringozTime: 'eta' }}</span>
      </div>
    }
  </div>

  <bz-divider class="main-divider"></bz-divider>

  @if (columns()?.location) {
    <div class="flex layout-column br-body-2">
      @if (service().pickup) {
        <div class="layout-row">
          <span class="origin margin-right-5">P</span>
          <div class="layout-column">
            <span class="text-ellipsis">{{ service().pickup.address | bringozAddress }}</span>
            <span class="text-ellipsis">{{ service().pickup | timeWindow }}</span>
          </div>
        </div>
      }
      @if (service().destination) {
        <div class="layout-row">
          <span class="destination margin-right-5">D</span>
          <div class="layout-column">
            <span class="text-ellipsis">{{ service().destination.address | bringozAddress }}</span>
            <span class="text-ellipsis">{{ service().destination | timeWindow }}</span>
          </div>
        </div>
      }
    </div>
  }
</div>
